export default class GUIDHelper {
    static get() {
        const guidGenerator = function guidGenerator() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        };

        return `${guidGenerator()}${guidGenerator()}-${guidGenerator()}-${guidGenerator()}-${guidGenerator()}-${guidGenerator()}${guidGenerator()}${guidGenerator()}`;
    }
}
